export const breakpoints: any = {
    values: {
        xs: 0,
        sm: 768,
        md: 960,
        lg: 1280,
        lgup: 1440,
        xl: 1920,
    },
}